import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { shockwave_locations_key } from "./selectShockwaveLocations";

interface ShockwaveLocation {
	orthopaedic_area: string;
	site: string;
	subsite: string;
}

interface Props {
	user_id: string;
	location: ShockwaveLocation;
}

export async function handleNewShockwaveLocation(props: Props) {
	const { data, error } = await supabaseClient.rpc(
		"handle_new_shockwave_location",
		{
			p_user_id: props.user_id,
			p_orthopaedic_area: props.location.orthopaedic_area,
			p_site: props.location.site,
			p_subsite: props.location.subsite,
		},
	);

	if (error) throw error;
	return data;
}

export const useHandleNewShockwaveLocation = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationKey: ["new-shockwave-location"],
		mutationFn: handleNewShockwaveLocation,
		onError: (error) => {
			toast.error("Failed to create shockwave location");
			console.error(error);
		},
		onSuccess: (locationId) => {
			toast.success("New shockwave location created");
			return locationId;
		},
		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: shockwave_locations_key,
			});
		},
	});
};
